"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[474],{

/***/ 9474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ calculation; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addYears/index.js
var addYears = __webpack_require__(21593);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/parseISO/index.js + 1 modules
var parseISO = __webpack_require__(78420);
// EXTERNAL MODULE: ./node_modules/jotai/esm/react.mjs
var react = __webpack_require__(48583);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-final-form/dist/react-final-form.es.js
var react_final_form_es = __webpack_require__(66688);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInDays/index.js + 1 modules
var differenceInDays = __webpack_require__(29383);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInWeeks/index.js + 1 modules
var differenceInWeeks = __webpack_require__(28584);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInMonths/index.js + 4 modules
var differenceInMonths = __webpack_require__(82161);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/differenceInYears/index.js + 1 modules
var differenceInYears = __webpack_require__(31397);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(77349);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addWeeks/index.js
var addWeeks = __webpack_require__(63500);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/addMonths/index.js
var addMonths = __webpack_require__(11640);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(3151);
;// CONCATENATED MODULE: ./utils/calculation/time-periods.ts









function getTimePeriods(_ref) {
  var startDate = _ref.startDate,
      endDate = _ref.endDate,
      stackingFrequency = _ref.stackingFrequency;

  switch (stackingFrequency) {
    case "DAILY":
      return (0,differenceInDays/* default */.Z)(endDate, startDate) + 1;

    case "WEEKLY":
      return (0,differenceInWeeks/* default */.Z)(endDate, startDate) + 1;

    case "MONTHLY":
      return (0,differenceInMonths/* default */.Z)(endDate, startDate) + 1;

    case "YEARLY":
      return (0,differenceInYears/* default */.Z)(endDate, startDate) + 1;
  }
}
;
function getTimePeriodDates(_ref2) {
  var numTimePeriods = _ref2.numTimePeriods,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      stackingFrequency = _ref2.stackingFrequency;
  var dates = Array.from(Array(numTimePeriods).keys()).map(function (_, idx) {
    if (idx === 0) return startDate;

    switch (stackingFrequency) {
      case "DAILY":
        return (0,addDays/* default */.Z)(startDate, idx);

      case "WEEKLY":
        return (0,addWeeks/* default */.Z)(startDate, idx);

      case "MONTHLY":
        return (0,addMonths/* default */.Z)(startDate, idx);

      case "YEARLY":
        return (0,addYears/* default */.Z)(startDate, idx);
    }
  });
  var stackOnLast = true;

  if (!(0,isSameDay/* default */.Z)(dates[dates.length - 1], endDate)) {
    dates.push(endDate);
    stackOnLast = false;
  }

  return {
    dates: dates,
    stackOnLast: stackOnLast
  };
}
// EXTERNAL MODULE: ./node_modules/decimal.js/decimal.mjs
var decimal = __webpack_require__(90482);
// EXTERNAL MODULE: ./node_modules/everpolate/lib/everpolate.js
var everpolate = __webpack_require__(35064);
;// CONCATENATED MODULE: ./utils/calculation/interpolation.ts


function interpolateRates(_ref) {
  var pricePredictions = _ref.pricePredictions,
      timePeriods = _ref.timePeriods,
      startDate = _ref.startDate;
  var basePredictions = pricePredictions.filter(function (_ref2) {
    var date = _ref2.date,
        value = _ref2.value;
    return !!date;
  });

  if (basePredictions.length < 2) {
    // why 2 non-zero?
    // we need at least 2 non-zero points to draw a straight line and interpolate between.
    return null;
  }

  var priceXs = basePredictions.map(function (_ref3) {
    var date = _ref3.date;
    return (0,differenceInDays/* default */.Z)(date, startDate);
  });
  var priceYs = basePredictions.map(function (_ref4) {
    var value = _ref4.value;
    return Number(value);
  });
  var desiredXs = timePeriods.map(function (date) {
    return (0,differenceInDays/* default */.Z)(date, startDate);
  });
  var outputs = (0,everpolate.linear)(desiredXs, priceXs, priceYs);
  return outputs;
}
// EXTERNAL MODULE: ./node_modules/date-fns/esm/subYears/index.js
var subYears = __webpack_require__(59319);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/startOfYear/index.js
var startOfYear = __webpack_require__(38148);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/endOfYear/index.js
var endOfYear = __webpack_require__(10876);
;// CONCATENATED MODULE: ./utils/calculation/cpi-rates.ts




function calculateCpiRateByYears(totalYears, inflationPercentage) {
  var rate = (100 + Number.parseFloat(inflationPercentage)) / 100;
  return Math.pow(rate, totalYears);
}

function cpiRatesHelper(startDate, endDate, timePeriods, inflationPercentage) {
  var rates = [];

  for (var i = 0; i < timePeriods.length; i++) {
    var diffInYears = Math.abs((0,differenceInYears/* default */.Z)(startDate, timePeriods[i]));
    var diffPureDays = Math.abs((0,differenceInDays/* default */.Z)(startDate, (0,subYears/* default */.Z)(timePeriods[i], diffInYears)));
    var totalDaysInYear = Math.abs((0,differenceInDays/* default */.Z)((0,startOfYear/* default */.Z)(timePeriods[i]), (0,endOfYear/* default */.Z)(timePeriods[i]))) + 1;
    var pureDaysRate = diffPureDays / totalDaysInYear * inflationPercentage / 100 + 1;
    var yearsRate = calculateCpiRateByYears(diffInYears, inflationPercentage);
    rates[i] = yearsRate * pureDaysRate;
  }

  return rates;
}
function cpiRates(fiat, rates, index) {
  return Math.pow(fiat, 2) / (rates[index] * fiat);
}
;// CONCATENATED MODULE: ./utils/calculation/index.ts







function formatTable(labels, columns) {
  var nRows = columns[0].length;
  return Array.from(Array(nRows)).map(function (_, idx) {
    var row = {};
    labels.forEach(function (label, columnIdx) {
      row[label] = columns[columnIdx][idx];
    });
    return row;
  });
}

function calculateSatsGoal(_ref) {
  var _interpolateRates, _interpolateRates2, _Decimal, _Decimal2, _investmentReturn$tim;

  var useStackingAmount = _ref.useStackingAmount,
      stackingAmount = _ref.stackingAmount,
      currentStackWithoutAvg = _ref.currentStack,
      avgCostPerBTCPrice = _ref.avgCostPerBTCPrice,
      goal = _ref.goal,
      startDate = _ref.startDate,
      endDate = _ref.endDate,
      stackingFrequency = _ref.stackingFrequency,
      pricePredictions = _ref.pricePredictions,
      increaseWithInflation = _ref.increaseWithInflation,
      inflationPercent = _ref.inflationPercent,
      supplyLimit = _ref.supplyLimit,
      calculateFuturePurchasingPower = _ref.calculateFuturePurchasingPower,
      isSatoshis = _ref.isSatoshis;
  // work out how many stacking periods there are between startDate and endDate
  var numTimePeriods = getTimePeriods({
    startDate: startDate,
    endDate: endDate,
    stackingFrequency: stackingFrequency
  }); // get the dates of those stacking periods

  var _getTimePeriodDates = getTimePeriodDates({
    numTimePeriods: numTimePeriods,
    startDate: startDate,
    endDate: endDate,
    stackingFrequency: stackingFrequency
  }),
      timePeriods = _getTimePeriodDates.dates,
      stackOnLast = _getTimePeriodDates.stackOnLast; // interpolate the exchange rates at each time period
  //
  // fiatToCryptoRates -> £100 * rate = ? BTC/Sats
  // cryptoToFiatRates => 1BTC/Sats * rate = £?
  // Returns the estimated cost of btc at each time period


  var cryptoToFiatRates = (_interpolateRates = interpolateRates({
    startDate: startDate,
    timePeriods: timePeriods,
    pricePredictions: pricePredictions
  })) === null || _interpolateRates === void 0 ? void 0 : _interpolateRates.map(function (value) {
    return new decimal/* Decimal */.t(value);
  }); // Returns the estimated cost of fiat at each time period

  var fiatToPurchasingFiatRates = (_interpolateRates2 = interpolateRates({
    startDate: startDate,
    timePeriods: timePeriods,
    pricePredictions: [{
      date: startDate,
      value: 0
    }, {
      date: endDate,
      value: inflationPercent / 100
    }]
  })) === null || _interpolateRates2 === void 0 ? void 0 : _interpolateRates2.map(function (value) {
    return new decimal/* Decimal */.t(value);
  });
  var fiatToCryptoRates = cryptoToFiatRates === null || cryptoToFiatRates === void 0 ? void 0 : cryptoToFiatRates.map(function (value) {
    return new decimal/* Decimal */.t(1).dividedBy(value);
  });
  if (!cryptoToFiatRates || !fiatToCryptoRates || useStackingAmount && increaseWithInflation && !inflationPercent || useStackingAmount && !stackingAmount || // no price prediction is provided
  !pricePredictions || !pricePredictions[1].value) return {};
  var currentStack = +currentStackWithoutAvg;
  var currentStackCalculation = cryptoToFiatRates[0];
  var avgBTCAsDecimal = new decimal/* Decimal */.t(avgCostPerBTCPrice || 0);
  var currentStackAtAvgBTCCostRate = (_Decimal = new decimal/* Decimal */.t(currentStack)) === null || _Decimal === void 0 ? void 0 : _Decimal.mul(avgBTCAsDecimal);
  var currentStackAtTodaysRate = (_Decimal2 = new decimal/* Decimal */.t(currentStack || 0)) === null || _Decimal2 === void 0 ? void 0 : _Decimal2.mul(currentStackCalculation);
  var fiatCurrentStack = !!avgCostPerBTCPrice ? currentStackAtAvgBTCCostRate : currentStackAtTodaysRate;
  var amountToInvest, invested;

  if (useStackingAmount) {
    amountToInvest = new decimal/* Decimal */.t(stackingAmount);

    if (increaseWithInflation) {
      invested = timePeriods.map(function (date) {
        var yearsApart = new decimal/* Decimal */.t((0,differenceInYears/* default */.Z)(date, startDate)); // 1 + precent increase

        var increaseRate = new decimal/* Decimal */.t(1).plus(new decimal/* Decimal */.t(inflationPercent).dividedBy(new decimal/* Decimal */.t(100)));
        return amountToInvest.times(increaseRate.pow(new decimal/* Decimal */.t(yearsApart)));
      });
    } else {
      invested = timePeriods.map(function () {
        return new decimal/* Decimal */.t(amountToInvest);
      });
    }
  } else {
    // calculate the monthly fiat amount
    var sumRates = fiatToCryptoRates.reduce(function (acc, rate, idx) {
      if (!stackOnLast && idx === fiatToCryptoRates.length - 1) return acc; // don't count the last if we're not stacking on it

      return acc.plus(rate);
    }, new decimal/* Decimal */.t(0));
    amountToInvest = new decimal/* Decimal */.t(goal).minus(currentStack || 0).dividedBy(sumRates);
    invested = timePeriods.map(function () {
      return new decimal/* Decimal */.t(amountToInvest);
    });
  }

  if (!stackOnLast) {
    invested[invested.length - 1] = new decimal/* Decimal */.t(0);
  }

  if (currentStack) {
    invested[0] = fiatCurrentStack.plus(invested[0]);
  }

  var breachedLimit = false; // how much crypto did we buyin this time period

  var stackedCrypto = cryptoToFiatRates.map(function (rate, idx) {
    if (idx === 0 && currentStack && !!avgCostPerBTCPrice) {
      var investedMinusCurrentStack = invested[0].minus(currentStackAtAvgBTCCostRate);
      return investedMinusCurrentStack.dividedBy(rate);
    }

    return invested[idx].dividedBy(rate);
  }); // what is our running crypto balance

  var cumulativeTotalCrypto = stackedCrypto.reduce(function (arr, stacked, idx) {
    var lastTotal = arr.length > 0 ? arr[arr.length - 1] : new decimal/* Decimal */.t(0);
    var newTotal = lastTotal.plus(stacked);

    if (newTotal.greaterThanOrEqualTo(new decimal/* Decimal */.t(supplyLimit))) {
      breachedLimit = true;
      newTotal = new decimal/* Decimal */.t(supplyLimit);
      var newStacked = newTotal.minus(lastTotal);
      invested[idx] = newStacked.times(cryptoToFiatRates[idx]);
      stackedCrypto[idx] = newStacked;
    }

    if (idx === 0 && !!currentStack) return [].concat((0,toConsumableArray/* default */.Z)(arr), [stacked.plus(currentStack)]);
    return [].concat((0,toConsumableArray/* default */.Z)(arr), [newTotal]);
  }, []); // therefore, what is our investment worth at each time period in fiat currency

  var cumulativeTotalFiat = cumulativeTotalCrypto.map(function (crypto, idx) {
    var rate = cryptoToFiatRates[idx];
    return crypto.times(rate);
  }, []);
  var cpiHelper = cpiRatesHelper(startDate, endDate, timePeriods, inflationPercent);
  var cumulativeTotalFiatPurchasingPower = cumulativeTotalFiat.map(function (totalFiat, idx) {
    if (!calculateFuturePurchasingPower) {
      return undefined;
    }

    var rate = fiatToPurchasingFiatRates[idx]; // return new Decimal(cumulativeTotalFiat[idx]).minus(totalFiat.times(rate))

    return new decimal/* Decimal */.t(cpiRates(cumulativeTotalFiat[idx].toNumber(), cpiHelper, idx));
  });
  var cumulativeInvestedFiat = invested.reduce(function (arr, investedSingle) {
    var last = arr.length ? arr[arr.length - 1] : new decimal/* Decimal */.t(0);
    return [].concat((0,toConsumableArray/* default */.Z)(arr), [last.plus(investedSingle)]);
  }, []);
  var fiatValueDelta = cumulativeTotalFiat.reduce(function (arr, fiatValue) {
    var previous = arr.length > 0 ? arr[arr.length - 1] : new decimal/* Decimal */.t(0);
    var delta = fiatValue.minus(previous);
    return [].concat((0,toConsumableArray/* default */.Z)(arr), [delta]);
  }, []);
  var fiatValueDeltaPercentage = cumulativeTotalFiat.reduce(function (arr, fiatValue, idx) {
    var previous = idx === 0 ? new decimal/* Decimal */.t(0) : cumulativeTotalFiat[idx - 1];
    var delta = fiatValue.minus(previous);
    var deltaPercentage = previous.greaterThan(0) ? delta.dividedBy(previous) : null;
    return [].concat((0,toConsumableArray/* default */.Z)(arr), [deltaPercentage]);
  }, []);
  var cumulativeFiatGain = cumulativeTotalFiat.reduce(function (arr, total, idx) {
    var totalInvested = cumulativeInvestedFiat[arr.length]; // When sats, the gain is much less

    var gain = total.minus(totalInvested);
    return [].concat((0,toConsumableArray/* default */.Z)(arr), [gain]);
  }, []);
  var fiatGain = cumulativeFiatGain.reduce(function (arr, gain) {
    var lastGain = arr.length > 0 ? cumulativeFiatGain[arr.length - 1] : new decimal/* Decimal */.t(0);
    return [].concat((0,toConsumableArray/* default */.Z)(arr), [gain.minus(lastGain)]);
  }, []);
  var tableData = formatTable(['date', 'cryptoToFiatRates', 'fiatToCryptoRates', 'stackedCrypto', 'cumulativeTotalCrypto', 'cumulativeTotalFiat', 'fiatValueDelta', 'fiatValueDeltaPercentage', 'cumulativeInvestedFiat', 'fiatGain', 'cumulativeFiatGain', 'cumulativeTotalFiatPurchasingPower'], [timePeriods, cryptoToFiatRates, fiatToCryptoRates, stackedCrypto, cumulativeTotalCrypto, cumulativeTotalFiat, fiatValueDelta, fiatValueDeltaPercentage, cumulativeInvestedFiat, fiatGain, cumulativeFiatGain, cumulativeTotalFiatPurchasingPower]); // singlestats

  var totalValue = cumulativeTotalFiat[cumulativeTotalFiat.length - 1];
  var totalInvested = invested.reduce(function (acc, amount) {
    return acc.plus(amount);
  }, new decimal/* Decimal */.t(0));
  var totalCrypto = cumulativeTotalCrypto[cumulativeTotalCrypto.length - 1];
  var averageCryptoPrice = totalInvested.dividedBy(totalCrypto);
  var investmentReturn = totalValue === null || totalValue === void 0 ? void 0 : totalValue.minus(totalInvested);
  var investmentReturnPercentage = investmentReturn === null || investmentReturn === void 0 ? void 0 : (_investmentReturn$tim = investmentReturn.times(new decimal/* Decimal */.t(100))) === null || _investmentReturn$tim === void 0 ? void 0 : _investmentReturn$tim.dividedBy(totalInvested);
  var singleStatData = {
    totalInvested: totalInvested,
    totalValue: totalValue,
    averageCryptoPrice: averageCryptoPrice,
    investmentReturn: investmentReturn,
    investmentReturnPercentage: investmentReturnPercentage,
    totalCrypto: totalCrypto,
    purchasingPower: cumulativeTotalFiatPurchasingPower && cumulativeTotalFiatPurchasingPower.length ? cumulativeTotalFiatPurchasingPower[cumulativeTotalFiatPurchasingPower.length - 1] : null
  }; // create outputs table at each time period

  return {
    numTimePeriods: numTimePeriods,
    startDate: startDate,
    amountToInvest: amountToInvest,
    tableData: tableData,
    singleStatData: singleStatData,
    breachedLimit: breachedLimit,
    stackOnLast: stackOnLast
  };
}
// EXTERNAL MODULE: ./utils/date.js
var date = __webpack_require__(90144);
// EXTERNAL MODULE: ./utils/useCryptoValue.js
var useCryptoValue = __webpack_require__(19319);
// EXTERNAL MODULE: ./atoms/calculator.js
var calculator = __webpack_require__(34822);
// EXTERNAL MODULE: ./utils/convertBtcSats.js
var convertBtcSats = __webpack_require__(72583);
// EXTERNAL MODULE: ./utils/logicContext.js
var logicContext = __webpack_require__(73839);
// EXTERNAL MODULE: ./components/content/calculator/calculationContext.js
var calculationContext = __webpack_require__(93138);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/content/calculator/calculation.js


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }















function formattedGrowth(growthValue) {
  if (typeof growthValue !== 'number') {
    return growthValue.split('_')[0];
  }

  return growthValue;
}

var getPricePoints = function getPricePoints(_ref) {
  var pricePredictions = _ref.pricePredictions,
      showPrediction = _ref.showPrediction,
      growth = _ref.growth,
      startDate = _ref.startDate,
      goalDate = _ref.goalDate,
      priceNow = _ref.priceNow,
      isSatoshis = _ref.isSatoshis;

  // user has input custom points
  if (showPrediction && pricePredictions) {
    return pricePredictions.filter(function (_ref2) {
      var date = _ref2.date,
          value = _ref2.value;
      return date && value;
    }).map(function (_ref3) {
      var date = _ref3.date,
          value = _ref3.value;
      return {
        date: date,
        value: value
      };
    });
  } // growth rate specified


  var growthFactor = 1 + formattedGrowth(growth) / 100;
  var pricePoints = [{
    date: startDate,
    value: priceNow
  }];

  while (pricePoints[pricePoints.length - 1].date < goalDate) {
    var lastPoint = pricePoints[pricePoints.length - 1];
    pricePoints.push({
      date: (0,addYears/* default */.Z)(lastPoint.date, 1),
      value: lastPoint.value * growthFactor
    });
  }

  return pricePoints;
};

var Calculation = function Calculation(_ref4) {
  var children = _ref4.children;
  var startingStack = (0,react/* useAtomValue */.Dv)(calculator/* startingStackAtom */.$_);
  var avgStartStackBTCPrice = (0,react/* useAtomValue */.Dv)(calculator/* avgCostPerBTCPriceAtom */.fm);

  var _useFormState = (0,react_final_form_es.useFormState)(),
      valid = _useFormState.valid,
      _useFormState$values = _useFormState.values,
      useStackingAmount = _useFormState$values.useStackingAmount,
      stackingAmount = _useFormState$values.stackingAmount,
      goal = _useFormState$values.goal,
      rawGoalDate = _useFormState$values.goalDate,
      stackingFrequency = _useFormState$values.stackingFrequency,
      currency = _useFormState$values.currency,
      isSatoshis = _useFormState$values.isSatoshis,
      pricePredictions = _useFormState$values.pricePredictions,
      showPrediction = _useFormState$values.showPrediction,
      growth = _useFormState$values.growth,
      increaseWithInflation = _useFormState$values.increaseWithInflation,
      inflationPercent = _useFormState$values.inflationPercent,
      calculateFuturePurchasingPower = _useFormState$values.calculateFuturePurchasingPower;

  var _useRawCryptoValue = (0,useCryptoValue/* useRawCryptoValue */.a)(),
      data = _useRawCryptoValue.data;

  var price = currency && data ? data[currency] : {};
  var priceNow = price;
  var defaultDate = (0,addYears/* default */.Z)(new Date(), 1);
  var goalDate = rawGoalDate instanceof Date ? rawGoalDate : rawGoalDate ? (0,parseISO/* default */.Z)(rawGoalDate) : defaultDate;
  var logic = (0,logicContext/* useLogic */.Z)();
  var supplyLimit = logic.BTCSupplyLimit;
  var startingStackBTC = isSatoshis ? +(0,convertBtcSats/* toBTC */.mg)(startingStack) : startingStack;
  var goalInBTC = isSatoshis ? +(0,convertBtcSats/* toBTC */.mg)(goal) : goal;
  var avgStackPriceToUse = avgStartStackBTCPrice === 0 ? priceNow : avgStartStackBTCPrice; // Checking inputs and show chart if it's valid

  var calculatedValues = node_modules_react.useMemo(function () {
    if (!valid) return {};
    if (growth === null) return {};
    var startDate = (0,date/* dateOnly */.hp)(new Date()); // JTD: All inputs are now in BTC

    return calculateSatsGoal({
      useStackingAmount: useStackingAmount,
      stackingAmount: stackingAmount,
      currentStack: startingStackBTC,
      avgCostPerBTCPrice: avgStackPriceToUse,
      startDate: startDate,
      endDate: goalDate,
      goal: goalInBTC,
      stackingFrequency: stackingFrequency,
      increaseWithInflation: increaseWithInflation,
      inflationPercent: inflationPercent,
      pricePredictions: getPricePoints({
        pricePredictions: pricePredictions,
        showPrediction: showPrediction,
        growth: growth,
        startDate: startDate,
        goalDate: goalDate,
        priceNow: priceNow,
        isSatoshis: isSatoshis
      }),
      supplyLimit: supplyLimit,
      calculateFuturePurchasingPower: calculateFuturePurchasingPower,
      isSatoshis: isSatoshis // might be needed for future calculations

    });
  }, [currency, valid, useStackingAmount, startingStack, avgStartStackBTCPrice, stackingAmount, goal, goalDate, stackingFrequency, pricePredictions, showPrediction, growth, isSatoshis, priceNow, increaseWithInflation, inflationPercent, supplyLimit, calculateFuturePurchasingPower]); // JTD: Investigate what is impacted - can this all be in BTC?

  var value = _objectSpread({
    useStackingAmount: useStackingAmount,
    stackingAmount: stackingAmount,
    currentStack: startingStack,
    goal: goal,
    goalDate: goalDate,
    stackingFrequency: stackingFrequency,
    currency: currency,
    isSatoshis: isSatoshis
  }, calculatedValues);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(calculationContext/* CalculationContext.Provider */.u.Provider, {
    value: value,
    children: children
  });
};

/* harmony default export */ var calculation = (Calculation);

/***/ }),

/***/ 90144:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hp": function() { return /* binding */ dateOnly; },
/* harmony export */   "mA": function() { return /* binding */ getOppositeDate; },
/* harmony export */   "ms": function() { return /* binding */ isBeforeBitcoinExistence; },
/* harmony export */   "p$": function() { return /* binding */ formatDateForHistoricApi; },
/* harmony export */   "qw": function() { return /* binding */ getYMD; }
/* harmony export */ });
/* unused harmony exports durationToString, mirrorDate, getDateFromString */
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16835);
/* harmony import */ var duration_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38174);
/* harmony import */ var duration_fns__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(duration_fns__WEBPACK_IMPORTED_MODULE_0__);




var dateOnly = function dateOnly(dateObj) {
  return new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate(), 0, 0, 0, 0);
};
var durationToString = function durationToString(goalDateSelect) {
  var parsedDuration = duration.parse(goalDateSelect);

  if (parsedDuration.years) {
    return "Last ".concat(parsedDuration.years, " year").concat(parsedDuration.years > 1 ? 's' : '');
  }

  if (parsedDuration.months) {
    return "Last ".concat(parsedDuration.months, " month").concat(parsedDuration.months > 1 ? 's' : '');
  }

  if (parsedDuration.weeks) {
    return "Last ".concat(parsedDuration.weeks, " week").concat(parsedDuration.weeks > 1 ? 's' : '');
  }

  return '';
}; // input: a, b => output: a - | a - b |

var mirrorDate = function mirrorDate(dateLeft, dateRight) {
  var diffInMinutes = differenceInMinutes(dateRight, dateLeft);
  return subMinutes(dateLeft, diffInMinutes);
};
function getYMD(date) {
  return {
    year: date.getFullYear(),
    month: date.getMonth() + 1,
    day: date.getDate()
  };
}
function getOppositeDate(durationISO) {
  var period = duration_fns__WEBPACK_IMPORTED_MODULE_0__.parse(durationISO);
  var oppositePeriod = {};

  for (var _i = 0, _Object$entries = Object.entries(period); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    oppositePeriod[key] = -value;
  }

  return duration_fns__WEBPACK_IMPORTED_MODULE_0__.apply(new Date(), oppositePeriod);
}
function isBeforeBitcoinExistence(_ref) {
  var year = _ref.year,
      month = _ref.month,
      day = _ref.day;
  if (year < 2010) return true;

  if (year == 2010 && month < 7) {
    return true;
  }

  if (year == 2010 && month == 7 && day < 17) return true;
  return false;
}
function formatDateForHistoricApi(dateObject) {
  var year = dateObject.year,
      month = dateObject.month,
      day = dateObject.day; // Pad month and day with leading zero if they are less than 10

  var paddedMonth = month < 10 ? "0".concat(month) : "".concat(month);
  var paddedDay = day < 10 ? "0".concat(day) : "".concat(day);
  return "".concat(year, "-").concat(paddedMonth, "-").concat(paddedDay);
}
function getDateFromString(dateString) {
  var date = new Date(dateString);
  var year = date.getFullYear(); // JavaScript's getMonth() function returns a 0-based month, so we add 1 to get a 1-based month

  var month = date.getMonth() + 1;
  var day = date.getDate();
  return {
    year: year,
    month: month,
    day: day
  };
}

/***/ }),

/***/ 19319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCryptoValue; },
/* harmony export */   "a": function() { return /* binding */ useRawCryptoValue; }
/* harmony export */ });
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36864);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


function useRawCryptoValue(_ref) {
  var swrOptions = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _ref);

  var _useSWR = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)('/api/satsgoal-current', _objectSpread(_objectSpread({}, swrOptions), {}, {
    errorRetryCount: 10,
    errorRetryInterval: 200,
    refreshInterval: 300000,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  })),
      data = _useSWR.data,
      error = _useSWR.error,
      isValidating = _useSWR.isValidating;

  return {
    data: data,
    error: error,
    isValidating: isValidating
  };
}
function useCryptoValue() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var swrOptions = (0,_vercel_path0_node_modules_next_dist_compiled_babel_runtime_helpers_esm_extends_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, _ref2);

  var _useRawCryptoValue = useRawCryptoValue(_objectSpread({}, swrOptions)),
      data = _useRawCryptoValue.data,
      error = _useRawCryptoValue.error,
      isValidating = _useRawCryptoValue.isValidating;

  return {
    data: data,
    error: error,
    isValidating: isValidating
  };
}

/***/ })

}]);